// import React, { useEffect, useState } from "react";
// import "./Navbar.css"; // Import the CSS file
// import UserGrid from "../AddMember/AddMember";
// import ScheduleFollowUps from "../../ScheduleFollowUps/ScheduleFollowUps";
// import { Modal, Button } from "antd";
// import InviteMember from "app/scenes/Settings/components/InviteMember";
// import { userInfo, workspaceInfo } from "app/config/States/users";
// import { useRecoilState } from "recoil";
// import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
// import { apiGet } from "app/services/apiServices";
// import { useNavigate } from "react-router-dom";
// import Exemption from "../../Exempted_list/exemption";
// import GSTCredentials from "app/scenes/Credentials/components/GSTCredentials";
// import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
// import { UserAddOutlined } from '@ant-design/icons';
// import AddCCModal from "../../ScheduleFollowUps/AddCCModal";

// const NavbarPage = () => {
//   const [activeTab, setActiveTab] = useState("Schedule follow-ups");
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [filteredOptions, setFilteredOptions] = useState([]);
//   const [workspaces, setWorkspaces] = useState([]);
//   const [userDetails, setUserDetails] = useRecoilState(
//     userInfo || { workspaces: [] }
//   );

//   const [searchQuery, setSearchQuery] = useState("");
//   const [workspace, setWorkspace] = useRecoilState(workspaceInfo);

//   const [selectedWorkspace, setSelectedWorkspace] = useState(workspace || null);
//   const [selectedWorkspaceId, setSelectedWorkspaceId] = useState();

//   useEffect(() => {
//     // Fetch workspace data on mount
//     const fetchUserInfo = async () => {
//       try {
//         const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
//         console.log("API Response:", response);
//         if (response.status && response.data?.workspaces) {
//           setWorkspaces(response.data.workspaces);
//           setUserDetails({
//             ...userDetails,
//             workspaces: response.data.workspaces,
//           });
//           setWorkspace(response.data?.workspaces?.[0]?.name);
//           setSelectedWorkspace(response.data?.workspaces?.[0]?.name);
//           setFilteredOptions(response.data.workspaces); // Initialize filtered options
//           setSelectedWorkspaceId(response.data?.workspaces?.[0]?.id);
//         }
//       } catch (error) {
//         console.error("Error fetching user info:", error);
//       }
//     };

//     fetchUserInfo();
//   }, []);

//   const [showModal, setShowModal] = useState(false);

//   const handleOpenModal = () => {
//     setShowModal(true);
//   };

//   const handleMemberShipSuccess = () => {
//     console.log("Membership successfully updated");
//     setShowModal(false); // Close the modal on success
//   };

//   // Filter options based on the search query
//   const handleSearch = (e) => {
//     const query = e.target.value.toLowerCase();
//     setSearchQuery(query);
//     setFilteredOptions(
//       workspaces.filter((workspace) =>
//         workspace.name.toLowerCase().includes(query)
//       )
//     );
//   };

//   // Handle selection of a workspace
//   const handleSelectOption = (workspace) => {
//     setSelectedWorkspace(workspace.name);
//     setWorkspace(workspace.name);
//     setIsDropdownOpen(false);
//     setSearchQuery("");
//     setFilteredOptions(workspaces); // Reset the filtered options
//   };

//   const navigate = useNavigate();

//   const goBack = () => {
//     navigate(-1); // This will navigate the user back to the previous page
//   };
//   const [isAddCCModalVisible, setAddCCModalVisible] = useState(false);

//   const handleAddCCSuccess = (newRow) => {
//     // Do something with the new row, e.g., update a table
//     console.log("New CC Added:", newRow);
//   };

//   return (
//     <div style={{ display: 'flex'}}>
//       <div>
//         <PrimaryNavBhilosa />
//       </div>
//       <div style={{ width: '94%',height:'100vh' }}>
//         <div className="navbar">
//         <div style={{display:'flex', justifyContent:'space-between',width:'100%'}}>
//           <h2 className="settinghead">Settings</h2>
//             {activeTab === "Schedule follow-ups" && (
//               <Button className="CCbtn"   onClick={() => setAddCCModalVisible(true)}><UserAddOutlined  style={{width:'20px', height:'20px'}}/>CC a Colleague</Button>
//             )}
//           </div>
          
          
//           {/* <div className="navbar-right">
//           <button className="add-member-btn" onClick={handleOpenModal}>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="18"
//               height="18"
//               viewBox="0 0 25 24"
//               fill="none"
//             >
//               <path
//                 d="M16.25 19H22.25M19.25 16V22M6.25 21V19C6.25 17.9391 6.67143 16.9217 7.42157 16.1716C8.17172 15.4214 9.18913 15 10.25 15H14.25M8.25 7C8.25 8.06087 8.67143 9.07828 9.42157 9.82843C10.1717 10.5786 11.1891 11 12.25 11C13.3109 11 14.3283 10.5786 15.0784 9.82843C15.8286 9.07828 16.25 8.06087 16.25 7C16.25 5.93913 15.8286 4.92172 15.0784 4.17157C14.3283 3.42143 13.3109 3 12.25 3C11.1891 3 10.1717 3.42143 9.42157 4.17157C8.67143 4.92172 8.25 5.93913 8.25 7Z"
//                 stroke="white"
//                 stroke-width="1.33333"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               />
//             </svg>{" "}
//             Add Member
//           </button>
//         </div> */}
//         </div>

//         {/* Tabs */}
//         <div className="tabs">
//         <div
//             className={`tab ${activeTab === "Schedule follow-ups" ? "active-tab" : ""
//               }`}
//             onClick={() => setActiveTab("Schedule follow-ups")}
//           >
//             Schedule follow-up CC member
//           </div>
//           <div
//             className={`tab ${activeTab === "Members" ? "active-tab" : ""}`}
//             onClick={() => setActiveTab("Members")}
//           >
//             Members
//           </div>
//           <div
//             className={`tab ${activeTab === "Your Exempted Vendors" ? "active-tab" : ""
//               }`}
//             onClick={() => setActiveTab("Your Exempted Vendors")}
//           >
//             Your Exempted Vendors
//           </div>
//           {/* <div
//           className={`tab ${activeTab === "GSTIN creds" ? "active-tab" : ""}`}
//           onClick={() => setActiveTab("GSTIN creds")}
//         >
//           GSTIN creds
//         </div> */}
//         </div>

//         {/* Tab Content */}
//         <div className="tab-content" style={{flex:1 }}>
//           {activeTab === "Members" && (
//             <UserGrid selectedWorkspace={selectedWorkspaceId} />
//           )}
//           {activeTab === "Schedule follow-ups" && <ScheduleFollowUps />}
//           {activeTab === "Your Exempted Vendors" && <Exemption />}
//           {/* {activeTab === "GSTIN creds" && <GSTCredentials componentType/>} */}
//         </div>
//         <Modal
//           title="Add Members"
//           open={showModal}
//           footer={false}
//           onCancel={() => setShowModal(false)}
//           width={600}
//         >
//           <InviteMember
//             onClose={() => setShowModal(false)}
//             onSuccess={handleMemberShipSuccess}
//           />
//         </Modal>

//         <AddCCModal
//         visible={isAddCCModalVisible}
//         onClose={() => setAddCCModalVisible(false)}
//         onSuccess={handleAddCCSuccess}
//       />
       
//       </div>
//       {/* Navbar */}

//     </div>
//   );
// };

// export default NavbarPage;






//-----------------------------------------------------------//


import React, { useEffect, useState } from "react";
import "./Navbar.css"; // Import the CSS file
import UserGrid from "../AddMember/AddMember";
import ScheduleFollowUps from "../../ScheduleFollowUps/ScheduleFollowUps";
import { Modal, Button } from "antd";
import InviteMember from "app/scenes/Settings/components/InviteMember";
import { userInfo, workspaceInfo } from "app/config/States/users";
import { useRecoilState } from "recoil";
import { API_ENDPOINT_GET_USER_INFO } from "app/scenes/Auth/auth.constants";
import { apiGet } from "app/services/apiServices";
import { useNavigate } from "react-router-dom";
import Exemption from "../../Exempted_list/exemption";
import GSTCredentials from "app/scenes/Credentials/components/GSTCredentials";
import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
import { UserAddOutlined,ArrowLeftOutlined } from '@ant-design/icons';
import AddCCModal from "../../ScheduleFollowUps/AddCCModal";


const NavbarPage = () => {
  const [activeTab, setActiveTab] = useState("Schedule follow-ups");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [workspaces, setWorkspaces] = useState([]);
  const [userDetails, setUserDetails] = useRecoilState(
    userInfo || { workspaces: [] }
  );

  const [searchQuery, setSearchQuery] = useState("");
  const [workspace, setWorkspace] = useRecoilState(workspaceInfo);

  const [selectedWorkspace, setSelectedWorkspace] = useState(workspace || null);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState();

  useEffect(() => {
    // Fetch workspace data on mount
    const fetchUserInfo = async () => {
      try {
        const response = await apiGet(API_ENDPOINT_GET_USER_INFO, false);
        console.log("API Response:", response);
        if (response.status && response.data?.workspaces) {
          setWorkspaces(response.data.workspaces);
          setUserDetails({
            ...userDetails,
            workspaces: response.data.workspaces,
          });
          setWorkspace(response.data?.workspaces?.[0]?.name);
          setSelectedWorkspace(response.data?.workspaces?.[0]?.name);
          setFilteredOptions(response.data.workspaces); // Initialize filtered options
          setSelectedWorkspaceId(response.data?.workspaces?.[0]?.id);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    fetchUserInfo();
  }, []);

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleMemberShipSuccess = () => {
    console.log("Membership successfully updated");
    setShowModal(false); // Close the modal on success
  };

  // Filter options based on the search query
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setFilteredOptions(
      workspaces.filter((workspace) =>
        workspace.name.toLowerCase().includes(query)
      )
    );
  };

  // Handle selection of a workspace
  const handleSelectOption = (workspace) => {
    setSelectedWorkspace(workspace.name);
    setWorkspace(workspace.name);
    setIsDropdownOpen(false);
    setSearchQuery("");
    setFilteredOptions(workspaces); // Reset the filtered options
  };

  const navigate = useNavigate();

  const goBack = () => {
    console.log("clicked")
    navigate('/vendorfollowup/memebersetting');
  };
  const [isAddCCModalVisible, setAddCCModalVisible] = useState(false);

  const handleAddCCSuccess = (newRow) => {
    // Do something with the new row, e.g., update a table
    console.log("New CC Added:", newRow);
  };
  const [isDetailPageVisible, setIsDetailPageVisible] = useState(false);
  const handleBackToSchedule = () => {
    setIsDetailPageVisible(false);
  };

  return (
    <div className="navBarMain" style={{ display: 'flex'}}>
        <PrimaryNavBhilosa />
      <div className="navBarMainContent">
        <div className="navbar">
        <div style={{display:'flex', justifyContent:'space-between',width:'100%'}}>
          <div style={{display:'flex', gap:'15px'}}>
          {/* {activeTab === "Schedule follow-ups" && (
               <ArrowLeftOutlined  style={{color:'#0A8394', marginBottom:'12px'}}
               onClick={goBack}
               />
           )} */}
          <h2 className="settinghead">Settings</h2>
          </div>
            {activeTab === "Schedule follow-ups" && (
              <Button className="CCbtn"   onClick={() => setAddCCModalVisible(true)}><UserAddOutlined  style={{width:'20px', height:'20px'}}/>CC a Colleague</Button>
            )}
            {activeTab === "Members" && (
              <Button className="CCbtn"   onClick={() => setShowModal(true)}><UserAddOutlined  style={{width:'20px', height:'20px'}}/>Add Member</Button>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
        <div
            className={`tab ${activeTab === "Schedule follow-ups" ? "active-tab" : ""
              }`}
            onClick={() => setActiveTab("Schedule follow-ups")}
          >
            Schedule follow-up CC member
          </div>
          <div
            className={`tab ${activeTab === "Members" ? "active-tab" : ""}`}
            onClick={() => setActiveTab("Members")}
          >
            Members
          </div>
          <div
            className={`tab ${activeTab === "Your Exempted Vendors" ? "active-tab" : ""
              }`}
            onClick={() => setActiveTab("Your Exempted Vendors")}
          >
            Your Exempted Vendors
          </div>
        </div>

        {/* Tab Content */}
        {/* <div className="tab-content" style={{flex:1 }}>
          {activeTab === "Members" && (
            <UserGrid selectedWorkspace={selectedWorkspaceId} />
          )}
          {activeTab === "Schedule follow-ups" && <ScheduleFollowUps />}
          {activeTab === "Your Exempted Vendors" && <Exemption />}
        </div> */}
        <div className="tab-content" style={{flex:1 }}>
          {activeTab === "Members" && (
            <UserGrid selectedWorkspace={selectedWorkspaceId} />
          )}
          {activeTab === "Schedule follow-ups" && <ScheduleFollowUps />}
          {activeTab === "Your Exempted Vendors" && <Exemption />}
        </div>
        <Modal
          title="Add Members"
          open={showModal}
          footer={false}
          onCancel={() => setShowModal(false)}
          width={600}
        >
          <InviteMember
            onClose={() => setShowModal(false)}
            onSuccess={handleMemberShipSuccess}
          />
        </Modal>

        <AddCCModal
        visible={isAddCCModalVisible}
        onClose={() => setAddCCModalVisible(false)}
        onSuccess={handleAddCCSuccess}
      />
       
      </div>
    </div>
  );
};

export default NavbarPage;

